module.exports = __webpack_public_path__ + "static/roamingGif-e59ca713b0b05aed54790df349be187a.mp4";